import { useQuery } from "@tanstack/react-query";

const useQueryFetch = (queryKey, queryFn, options = {}) => {
  return useQuery({
    queryKey: [...(Array.isArray(queryKey) ? queryKey : [queryKey])],
    queryFn: async () => {
      const res = await queryFn();
      return res?.data || res;
    },
    ...options,
  });
};

export default useQueryFetch;
